// actions
import {
  DIRECTIONS_FETCH_REQUEST,
  DIRECTIONS_FETCH_SUCCESS,
  DIRECTIONS_FETCH_FAILURE,
  DIRECTIONS_CLEAR_ALL,
  DIRECTIONS_TOGGLE_UI,
  DIRECTIONS_UPDATE_LABELS,
  DIRECTIONS_DELETE_ERROR,
  DIRECTIONS_UPDATE_POLYLINE,
  DIRECTIONS_UPDATE_DISTANCE,
  DIRECTIONS_BIND_DRAGGABLE,
  DIRECTIONS_SHOW_ALTMAP,
} from './actions';

const Directions = (
  state = {
    directionsIsLoading: false,
    directions: [],
    directionsRequested: false,
    directionsLoaded: false,
    directionsError: false,
    distance: 0,
    duration: {
      hoursLabel: 'Duration: {HOURS} h ({FORMATTED_DISTANCE})',
      minutesLabel: 'Duration: {MINUTES} min ({FORMATTED_DISTANCE})',
      hoursMinutesLabel:
        'Duration: {HOURS} h {MINUTES} min ({FORMATTED_DISTANCE})',
    },
    button: {
      label: 'Show nearby Destination Charging',
    },
    charging: {
      label: '{DURATION} min charge',
    },
    path: [],
    draggable: false,
    showAltMap: false,
  },
  action,
) => {
  switch (action.type) {
    case DIRECTIONS_FETCH_REQUEST:
      return {
        ...state,
        directionsIsLoading: true,
        directionsRequested: true,
      };
    case DIRECTIONS_FETCH_SUCCESS:
      return {
        ...state,
        directionsIsLoading: false,
        directions: action.directions,
        directionsLoaded: true,
        directionsError: false,
      };
    case DIRECTIONS_FETCH_FAILURE:
      return {
        ...state,
        directionsIsLoading: false,
        directionsLoaded: false,
        directionsError: true,
        directionsRequested: false,
      };
    case DIRECTIONS_DELETE_ERROR:
      return {
        ...state,
        directionsError: false,
      };
    case DIRECTIONS_CLEAR_ALL:
      return {
        ...state,
        directions: [],
        directionsRequested: false,
        directionsLoaded: false,
      };
    case DIRECTIONS_TOGGLE_UI:
      return {
        ...state,
        directionsLoaded: action.loaded,
        directionsRequested: action.requested,
      };
    case DIRECTIONS_UPDATE_LABELS:
      return {
        ...state,
        duration: {
          hoursLabel: action.data.duration.hoursLabel,
          minutesLabel: action.data.duration.minutesLabel,
          hoursMinutesLabel: action.data.duration.hoursMinutesLabel,
        },
        button: {
          label: action.data.button.label,
        },
        charging: {
          label: action.data.charging.label,
        },
      };
    case DIRECTIONS_UPDATE_POLYLINE:
      return {
        ...state,
        polyline: action.polyline,
      };
    case DIRECTIONS_UPDATE_DISTANCE:
      return {
        ...state,
        distance: action.distance,
      };
    case DIRECTIONS_BIND_DRAGGABLE:
      return {
        ...state,
        draggable: action.draggable,
      };
    case DIRECTIONS_SHOW_ALTMAP:
      return {
        ...state,
        showAltMap: action.showAltMap,
      };
    default:
      return state;
  }
};

export default Directions;
